import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone, MessageCircle, Droplets } from "lucide-react";
import { COMPANY, NAV, waLink } from "@/data/site";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => setOpen(false), [location.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50" data-testid="site-header">
      <div className={`bg-white transition-shadow ${scrolled ? "shadow-md" : ""}`}>
        <div className="max-w-7xl mx-auto container-px flex items-center justify-between h-[72px]">
          <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
            <span className="grid place-items-center w-9 h-9 rounded-md bg-brand-red text-white">
              <Droplets className="w-5 h-5" />
            </span>
            <span className="font-display font-extrabold text-xl leading-none">
              <span className="text-brand-black">Desentupidora </span>
              <span className="text-brand-red">Paulistana</span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-7" data-testid="desktop-nav">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                className={({ isActive }) =>
                  `text-sm font-semibold transition-colors ${
                    isActive ? "text-brand-red" : "text-brand-black hover:text-brand-red"
                  }`
                }
                data-testid={`nav-${n.label.toLowerCase()}`}
              >
                {n.label}
              </NavLink>
            ))}
          </nav>

          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden md:inline-flex btn-green !py-2.5 !px-4 text-sm"
            data-testid="header-whatsapp-btn"
          >
            <MessageCircle className="w-4 h-4" /> Chamar no WhatsApp
          </a>

          <button
            className="lg:hidden p-2 text-brand-black"
            onClick={() => setOpen((v) => !v)}
            aria-label="Abrir menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {open && (
          <div className="lg:hidden border-t border-gray-100 bg-white" data-testid="mobile-nav">
            <nav className="max-w-7xl mx-auto container-px py-4 flex flex-col gap-1">
              {NAV.map((n) => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  end={n.to === "/"}
                  className={({ isActive }) =>
                    `py-2.5 font-semibold ${isActive ? "text-brand-red" : "text-brand-black"}`
                  }
                  data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                >
                  {n.label}
                </NavLink>
              ))}
              <a href={waLink()} target="_blank" rel="noopener noreferrer" className="btn-green mt-3" data-testid="mobile-whatsapp-btn">
                <MessageCircle className="w-4 h-4" /> Chamar no WhatsApp
              </a>
            </nav>
          </div>
        )}
      </div>

      {/* Barra de urgência escura */}
      <div className="bg-brand-black text-white" data-testid="urgency-bar">
        <div className="max-w-7xl mx-auto container-px h-10 flex items-center justify-between gap-3 text-[11px] sm:text-sm">
          <span className="flex items-center gap-1.5 sm:gap-2 font-medium whitespace-nowrap">
            <span className="w-2 h-2 rounded-full bg-wa-green animate-pulse" />
            <span className="sm:hidden">Atendimento agora</span>
            <span className="hidden sm:inline">Atendimento agora • Resposta em até 15min</span>
          </span>
          <a href={`tel:${COMPANY.phoneTel}`} className="flex items-center gap-1.5 sm:gap-2 font-bold whitespace-nowrap hover:text-brand-yellow transition-colors" data-testid="urgency-phone">
            <Phone className="w-4 h-4" /> {COMPANY.phoneDisplay}
          </a>
        </div>
      </div>
    </header>
  );
};
